import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { BranchInformationModel } from '../../models/branch-information.model'
import { OrganizationsService } from '../../services/organizations.service'
import { Subscription } from 'rxjs'
import { TranslateService } from '@ngx-translate/core'
import { ToastrService } from 'ngx-toastr'

@Component({
	selector: 'app-organization-branch-settings',
	templateUrl: './organization-branch-settings.component.html',
	styleUrls: ['./organization-branch-settings.component.scss'],
})
export class OrganizationBranchSettingsComponent
	implements OnInit, OnChanges, OnDestroy
{
	@Input() branchInformationData!: BranchInformationModel
	editMode: boolean = false
	settingsForm: FormGroup = new FormGroup({})
	subscription = new Subscription()
	reservationPerDayOldNumber!: number
	reservationPerTimeSlotOldNumber!: number
	constructor(
		private OrganizationsService: OrganizationsService,
		private translate: TranslateService,
		private toaster: ToastrService
	) {}

	ngOnInit(): void {}
	ngOnChanges() {
		this.initForm()
		this.reservationPerDayOldNumber =
			this.branchInformationData?.reservationsNumberPerDay
		this.reservationPerTimeSlotOldNumber =
			this.branchInformationData?.reservationsNumberPerTimeSlot
	}
	initForm() {
		this.settingsForm = new FormGroup({
			reservationPerDay: new FormControl(
				this.branchInformationData?.reservationsNumberPerDay,
				[Validators.required, Validators.min(1)]
			),
			reservationPerTimeSlot: new FormControl(
				this.branchInformationData?.reservationsNumberPerTimeSlot,
				[Validators.required, Validators.min(1)]
			),
		})
		this.settingsForm.disable()
	}

	changeEditMode() {
		this.editMode = !this.editMode
		this.editMode ? this.settingsForm.enable() : this.settingsForm.disable()
	}

	cancelAction() {
		this.settingsForm.patchValue({
			reservationPerDay: this.branchInformationData.reservationsNumberPerDay,
			reservationPerTimeSlot:
				this.branchInformationData.reservationsNumberPerTimeSlot,
		})
	}

	getController(controlName: string) {
		return this.settingsForm.controls[controlName] as FormControl
	}

	isNumber(evt: any) {
		evt = evt ? evt : window.event
		var charCode = evt.which ? evt.which : evt.keyCode
		if (charCode > 31 && (charCode < 48 || charCode > 57)) {
			return false
		}
		return true
	}

	saveAction() {
		const body = {
			id: this.branchInformationData.id,
			reservationsNumberPerDay:
				this.settingsForm?.get('reservationPerDay')?.value,
			reservationsNumberPerTimeSlot: this.settingsForm?.get(
				'reservationPerTimeSlot'
			)?.value,
		}
		this.subscription.add(
			this.OrganizationsService.updateBranchSettings(body).subscribe(
				(res: any) => {
					this.branchInformationData.reservationsNumberPerDay =
						body.reservationsNumberPerDay
					this.branchInformationData.reservationsNumberPerTimeSlot =
						body.reservationsNumberPerTimeSlot
					this.changeEditMode()
					this.toaster.success(this.translate.instant('TOASTER.MSG_SUCCESS'))
				}
			)
		)
	}

	checkDisabled() {
		return (
			this.settingsForm.invalid ||
			(this.branchInformationData?.reservationsNumberPerDay ==
				this.settingsForm?.get('reservationPerDay')?.value &&
				this.branchInformationData?.reservationsNumberPerTimeSlot ==
					this.settingsForm?.get('reservationPerTimeSlot')?.value)
		)
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe()
	}
}
